import React from 'react';
import Subscription from '../../../models/subscription';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContextMenu, Button, DropdownItem, LinkWithActions } from '@weezevent/nacre';
import NavTitle from './NavTitle';
import Style from './style/context-menu.module.css';

export default function WebserviceContextMenu({ organization, webservice }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [search, setSearch] = React.useState(null);
    const tooltipUrl = `${window.weezConfig.api.apiUrl}/ticket-imports/organizations/${organization.id}/hooks/${webservice?.hook_uuid}`;

    const [subscriptions] = Subscription.useApiModel(
        {
            organizationId: organization.id,
            query: {
                search
            }
        },
        [organization, search]
    );

    const handleSwitch = React.useCallback(
        subscription => {
            history.push(`/ticket/O${organization.id}/webservices/${subscription.id}/attendees`);
        },
        [history, organization]
    );

    const handleRoot = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/webservices/new`);
    }, [history, organization, webservice]);

    const webserviceList = React.useMemo(() => {
        let list = [];
        subscriptions
            ?.filter(s => {
                if (search) {
                    return s?.name?.toLowerCase().includes(search?.toLowerCase());
                }
                return s.type === 'hook';
            })
            .forEach(s => {
                list.push(
                    <DropdownItem key={s.id} onClick={() => handleSwitch(s)}>
                        {s.name}
                    </DropdownItem>
                );
            });
        return list;
    }, [subscriptions, handleSwitch, search]);

    const defaultTooltipProps = {
        margin: false,
        triggerOnHover: true,
        position: 'top-start'
    };

    return (
        <ContextMenu
            withoutExternalLink
            catchphrase={<NavTitle title={t('ticket.switchWebservice.go_back')} link={`/ticket/O${organization.id}/webservices`} />}
            title={webservice.name}
            linkComponent={<LinkWithActions tooltipText={<div className={Style['break-word']}> {tooltipUrl}</div>} url={tooltipUrl} position="top-start" />}
            titleTooltipProps={{ ...defaultTooltipProps, title: webservice.name, offset: [0, -5] }}
            cta={
                <Button fluid onClick={handleRoot} primary>
                    {t('ticket.switchWebservice.cta-button')}
                </Button>
            }
            switchMenuProps={{
                text: t('ticket.switchWebservice.cta'),
                footerText: t('ticket.switchWebservice.footer_cta'),
                onFooterClick: () => history.push(`/ticket/O${organization.id}/webservices`),
                searchProps: {
                    onChange: (synth, value) => {
                        setSearch(value);
                    },
                    handleReset: () => setSearch(''),
                    value: search,
                    placeholder: t('ticket.switchWebservice.search_placeholder')
                },
                items: webserviceList
            }}
        />
    );
}
